import * as actionTypes from '../actions/actionTypes';

const initialState = {
  fetching: true,
  error: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        ...action.user,
        signedIn: true,
        fetching: false
      };
    case actionTypes.FETCH_USER_FAIL:
      return {
        ...state,
        signedIn: false,
        fetching: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/javascript/app/store/reducers/users.js